import React from 'react';
import { connect } from 'react-redux';
import HorizontalStepper from '../../components/Stepper/HorizontalStepper';
import MyTimeline from '../../components/Timeline/MyTimeline';
import './GoalDashboardPage.css';
import { trackPromise } from 'react-promise-tracker';
require('dotenv').config();

class GoalDashboardPage extends React.Component {
  state = {};

  componentDidMount() {
    const {
      match: { params },
    } = this.props;
    const { param } = params;

    const { authedUser } = this.props;

    const objectives = [
      'obj1',
      'obj2',
      'obj3',
      'obj4',
      'obj5',
      'obj6',
      'obj7',
      'obj8',
      'obj9',
      'obj10',
      'obj11',
      'obj12',
    ];

    var requestOptions = {
      method: 'GET',
      redirect: 'follow',
    };

    this.setState({ currentObj: 'obj1' });
    trackPromise(
      fetch(
        `https://n4utl89pg0.execute-api.us-east-2.amazonaws.com/Prod?username=${authedUser}`,
        requestOptions
      )
        .then(response => response.text())
        .then(result => {
          JSON.parse(result).items.forEach(item => {
            const { answers, response_id } = item;
            if (response_id === param) {
              answers.forEach(answerField => {
                const field_ref = answerField.field.ref;
                const { text } = answerField;
                if (objectives.includes(field_ref)) {
                  this.setState({ [field_ref]: [text] });
                } else if (field_ref === 'title') {
                  this.setState({ title: text });
                } else if (field_ref === 'deadline') {
                  this.setState({ deadline: text });
                } else if (field_ref.slice(0, 3) === 'obj') {
                  const ref_splits = field_ref.split('s');
                  const obj = ref_splits[0];
                  this.setState(prevState => {
                    return { [obj]: prevState[obj].concat([text]) };
                  });
                } else if (field_ref === 'current_metric') {
                  this.setState({ current_metric: text });
                } else if (field_ref === 'target_metric') {
                  this.setState({ target_metric: text });
                } else if (field_ref === 'reminder_frequency') {
                  this.setState({
                    reminder_frequency: answerField.choice.label,
                  });
                }
              });
            }
          });
        })
        .catch(error => {})
    );
  }

  handleObjClick = index => {
    this.setState({ currentObj: `obj${index + 1}` });
  };

  render() {
    const objectivesKeys = Object.keys(this.state).filter(element =>
      element.startsWith('obj')
    );
    const objectives = objectivesKeys.map(obj => this.state[obj][0]);
    const { currentObj } = this.state;
    const dotContents = this.state[currentObj]
      ? this.state[currentObj].slice(1)
      : 'obj1';
    return (
      <div className='goal-dashboard-div'>
        <div style={{ display: 'inline' }}>
          <HorizontalStepper
            handleClick={this.handleObjClick}
            steps={objectives}
          />
          <MyTimeline dotContents={dotContents} />
        </div>
      </div>
    );
  }
}

function mapStateToProps({ authedUser }) {
  return {
    authedUser,
  };
}

export default connect(mapStateToProps)(GoalDashboardPage);
